<section class="relative flex flex-col items-center w-full min-w-0 overflow-x-hidden">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 px-2 sm:px-3">
    <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
      <div class="min-w-0">
        <h1 class="font-display text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">Certifications</h1>
        <p class="text-gray-500 mt-1">
          Récupérées automatiquement ou ajoutées manuellement.
        </p>
      </div>
      <label class="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-4 py-2.5 sm:py-2 bg-secondary text-white text-sm font-medium rounded-md cursor-pointer hover:bg-secondary-hover shrink-0">
        <span class="material-symbols-outlined text-[16px]">upload</span>
        @if (uploading()) { Envoi... } @else { Ajouter manuellement }
        <input type="file" class="hidden" (change)="onFileSelected($event)" [disabled]="uploading()" />
      </label>
    </div>

    @if (loading()) {
      <div class="rounded-xl border border-gray-200 bg-white p-8 text-center text-gray-500">
        Chargement des certifications...
      </div>
    } @else if (apiCertifications().length === 0 && files().length === 0) {
      <div class="rounded-2xl bg-white border border-gray-200 shadow-card p-10 flex flex-col items-center text-center">
        <div class="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mb-4">
          <span class="material-symbols-outlined text-gray-400 text-[30px]">workspace_premium</span>
        </div>
        <h3 class="text-lg font-semibold text-gray-900">Aucune certification</h3>
        <p class="text-sm text-gray-500 mt-1">Aucune certification publique trouvee. Vous pouvez ajouter vos justificatifs manuellement.</p>
      </div>
    } @else {
      @if (apiCertifications().length > 0) {
        <div class="space-y-4">
          <h2 class="text-lg font-semibold text-gray-900">Recuperees automatiquement ({{ apiCertifications().length }})</h2>
          <div class="grid sm:grid-cols-2 gap-4">
            @for (cert of apiCertifications(); track cert.label + cert.source + cert.dateFin) {
              <article class="rounded-xl bg-white border border-gray-200 p-5 shadow-card">
                <div class="flex items-start gap-3">
                  <div class="w-10 h-10 rounded-xl bg-secondary/10 flex items-center justify-center shrink-0">
                    <span class="material-symbols-outlined text-secondary">verified</span>
                  </div>
                  <div class="min-w-0 flex-1">
                    <h3 class="font-medium text-sm text-gray-900">{{ cert.label }}</h3>
                    @if (cert.description) {
                      <p class="text-xs text-gray-500 mt-1">{{ cert.description }}</p>
                    }
                    <p class="text-xs text-gray-500 mt-2">
                      Source: {{ cert.source }}
                      @if (cert.organisme) { · {{ cert.organisme }} }
                    </p>
                    @if (cert.dateFin) {
                      <p class="text-xs text-gray-500 mt-1">Valide jusqu'au {{ cert.dateFin | date: 'dd/MM/yyyy' }}</p>
                    }
                  </div>
                  @if (cert.urlCertificat) {
                    <a [href]="cert.urlCertificat" target="_blank" rel="noopener noreferrer" class="text-secondary text-sm hover:underline">
                      Ouvrir
                    </a>
                  }
                </div>
              </article>
            }
          </div>
        </div>
      }

      @if (files().length > 0) {
        <div class="space-y-4">
          <h2 class="text-lg font-semibold text-gray-900">Ajoutees manuellement ({{ files().length }})</h2>
          <div class="grid sm:grid-cols-2 gap-4">
            @for (file of files(); track file.id) {
              <article class="rounded-xl bg-white border border-gray-200 p-5 shadow-card">
                <div class="flex items-start gap-3">
                  <div class="w-10 h-10 rounded-xl bg-secondary/10 flex items-center justify-center shrink-0">
                    <span class="material-symbols-outlined text-secondary">upload</span>
                  </div>
                  <div class="min-w-0 flex-1">
                    <h3 class="font-medium text-sm text-gray-900 truncate">{{ file.originalFilename }}</h3>
                    <p class="text-xs text-gray-500 mt-1">{{ file.createdAt | date: 'dd/MM/yyyy HH:mm' }}</p>
                  </div>
                  <button
                    type="button"
                    class="text-secondary text-sm hover:underline cursor-pointer"
                    (click)="download(file)"
                  >
                    Ouvrir
                  </button>
                </div>
              </article>
            }
          </div>
        </div>
      }
    }
  </div>
</section>
